export class CampaignApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCampaigns(params) {
    return this.#http.get('/api/campaigns', { params });
  }

  async getCampaignById({ campaignId }) {
    return this.#http.get(`/api/campaigns/${campaignId}`);
  }

  async getCampaignAudience({ campaignId }) {
    return this.#http.get(`/api/campaigns/${campaignId}/audience`);
  }

  // Save authors the campaign's real steps (DEV-4400 / T6): the CRM Save handler authors the hidden
  // SourceType=DripCampaign LoanAction directly from the marketer's ordered steps (channel + the
  // channel-appropriate content — Email templateId / SMS message / Push title+body — + per-step delayDays)
  // + audience, and returns the CampaignModel (incl. compiledLoanActionId). Create → 201, Update → 200;
  // both take the SaveCampaignRequest body. Activation (below) is a separate step that just initiates
  // enrollment against the already-authored action.
  async createCampaign(request) {
    return this.#http.post('/api/campaigns', request);
  }

  async updateCampaign({ campaignId, request }) {
    return this.#http.put(`/api/campaigns/${campaignId}`, request);
  }

  // Activation initiates enrollment against the already-authored action (DEV-4341 T2): the CRM activate
  // handler flips the campaign Draft → Active and enrolls the audience through the CRM->LoanProcessing
  // bridge. The body's enrollExisting flag is the "enroll existing now vs only going-forward" choice.
  async activateCampaign({ campaignId, enrollExisting }) {
    return this.#http.post(`/api/campaigns/${campaignId}/activate`, { enrollExisting });
  }

  async getCampaignEnrollments({ campaignId }) {
    return this.#http.get(`/api/campaigns/${campaignId}/enrollments`);
  }
}
